import React, {createContext, useState} from 'react';
import { API, defaultError, config, closeSession } from "../config";
import axios from "axios";
import useSWR from 'swr';

const MyOpenDataContext = createContext();

const MyOpenDataProvider = ({ children }) => {
    const [error, setError] = useState({"error": false, "message": ""});
    const [loading, setLoading] = useState(false);
    /* const [localLoading, setLocalLoading] = useState(false); */
    /* const [count, setCount] = useState(0); */

    const fetcher = () => axios.get(`${API}/user-requests/get-count`).then(async res => {
        console.log(res.data)
        return res.data;
    })

    function useCounter(){
        const { data, error } = useSWR(`${API}/user-requests/get-count`, fetcher);
        return {
            count: data ? data?.response : "Ha ocurrido un error al obtener la cantidad de solicitudes, por favor recargue la página.",
            isLoading: !error && !data,
            isError: data?.error || error
        }
    }

    const createRequest = async ( data ) => {
        setLoading(true)
        var formData = new FormData();
        formData.append("userRequestName", data.userRequestName);
        formData.append("userRequestEmail", data.userRequestEmail);
        formData.append("userRequestPhone", data.userRequestPhone);
        formData.append("userRequestDocument", data.userRequestDocument);
        formData.append("userRequestAddress", data.userRequestAddress);

        config.headers["Content-Type"] = "multipart/form-data";
        try{
            const res = await axios.post(`${API}/user-requests/add`, data, config)
            setLoading(false);
            return res.data;
        } catch(err){
            setLoading(false);
            return defaultError;
        }
    }

    const getRequests = async () => {
        setLoading(true);
        try{
            const res = await axios.get(`${API}/user-requests/get-requests`, config)
            setError({ "error": false, "message": "" });
            if(res.data.status == "400-1"){
                closeSession();
            }
            if(res.data.error){
                setLoading(false);
                setError({ "error": true, "message": res.data.response });
                setTimeout(() => {
                    setError({ "error": false, "message": "" });
                }, 3000);
                return;
            }
            const binaryString = window.atob(res.data.response);
            const bytes = new Uint8Array(binaryString.length);
            for (let i = 0; i < binaryString.length; i++) {
                bytes[i] = binaryString.charCodeAt(i);
            }
            const url = window.URL.createObjectURL(new Blob([bytes], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }));

            const link = document.createElement('a');
            link.href = url;
            //link.setAttribute('download', filePath);
            link.setAttribute('download', 'Solicitudes' + new Date().toLocaleString() + '.xlsx');
            document.body.appendChild(link);
            link.click();
            setLoading(false);
        } catch(err){
            setLoading(false);
            setError({ "error": true, "message": "Ha ocurrido un error al descargar el archivo" });
            setTimeout(() => {
                setError({ "error": false, "message": "" });
            }, 3000);
        }
    }

    /* const getRequestsCount = async () => {
        setLocalLoading(true);
        try{
            const res = await axios.get(`${API}/user-requests/get-count`, config)
            setError({ "error": false, "message": "" });
            setLocalLoading(false);
            if(res.data.error){
                setError({ "error": true, "message": res.data.response });
                return;
            }
            setCount(res.data.response);
        } catch(err){
            setLocalLoading(false);
            setError({ "error": true, "message": "Ha ocurrido un error al obtener la cantidad de solicitudes, por favor intente nuevamente." });
            setCount(0);
        }
    } */

    return (
        <MyOpenDataContext.Provider value={{
            error,
            setError,
            loading,
            setLoading,
            createRequest,
            getRequests,
            useCounter
        }}>
            {children}
        </MyOpenDataContext.Provider>
    );
}
 
export { MyOpenDataProvider };
export default MyOpenDataContext;